// extracted by mini-css-extract-plugin
export default {"pageWrapper":"style_pageWrapper__MdMs1","collapseWrapper":"style_collapseWrapper__f3swO"};